import { Component, inject, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, Input, signal, OnInit, WritableSignal } from '@angular/core';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioButton, MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { questionnaire4Questions } from '../question-config/questionnaire4-config';
import { questionnaire1Questions } from '../question-config/questionnaire1-config';
import { questionnaire2Questions } from '../question-config/questionnaire2-config';
import { questionnaire3Questions } from '../question-config/questionnaire3-config';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { MatSelectModule } from '@angular/material/select';
import { DsuAdService } from '../ad-service/dsu-adservice/dsu-ad.service';
import { HttpStatusCode } from 'axios';
import { Router } from '@angular/router';
import { AddsuModel } from '../addsu-models/addsu.models';
import { DsuAdinterface, questionset } from '../ad-interface/dsu-ad.interface';
import { SelectOptions } from '../../../core/interfaces/select-options.interface';
import { ConfirmPopupComponent } from '../../agent-onboarding/new-rep-application/confirm-popup/confirm-popup.component';
import { merge, skip } from 'rxjs';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-dsu-annualdeclarationform',
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  imports: [
    PiasLayoutComponent,
    MatExpansionModule,
    ReactiveFormsModule,
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule,
    MatRadioModule,
    MatError,
    MatRadioButton,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule
  ],
  templateUrl: './dsu-annualdeclarationform.component.html',
  styleUrl: './dsu-annualdeclarationform.component.scss'
})
export class DsuAnnualdeclarationformComponent implements OnInit {

  // INJECTIONS
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private dsuAdService = inject(DsuAdService);
  private sanitizer = inject(DomSanitizer);
  private sessionservice = inject(SessionStorageService);
  private snackmessage = inject(SnackbarService);
  // STATE VARIABLES
  // declarationStatus: string;
  public formGroup!: FormGroup; // Declare here, initialize in ngOnInit
  declarationData!: DsuAdinterface;
  questionset!: questionset[];
  public message = 'This field is required';
  selectedUadsId!: number;
  submitmessage = '';

  setSprinner = signal(false);

  currentStep!: number;

  loggedInRole!: string;
  selectedUserrole!: string;
  selectedPiasRepcode!: string;

  workflowStatus!: string;

  showPreview = false;
  isPdf = false;
  currentFileName = '';
  selectedDocument: SafeResourceUrl | null = null;
  mode!: string;

  readonly MIN_ZOOM = 0.5;
  readonly MAX_ZOOM = 3;
  private readonly ZOOM_STEP = 0.25;
  zoomLevel = 1;


  // Assuming these are imported from a constants file
  questionnaire1Questions = questionnaire1Questions;
  questionnaire2Questions = questionnaire2Questions;
  questionnaire3Questions = questionnaire3Questions;
  questionnaire4Questions = questionnaire4Questions;

  questionnaire1FormValid = signal('In Review');
  questionnaire2FormValid = signal('In Review');
  questionnaire3FormValid = signal('In Review');
  questionnaire4FormValid = signal('In Review');

  formValidators = [
    this.questionnaire1FormValid,
    this.questionnaire2FormValid,
    this.questionnaire3FormValid,
    this.questionnaire4FormValid,
  ];


  data = history.state;
  protected nationalities!: SelectOptions[];
  protected countries!: SelectOptions[];



  ngOnInit(): void {
    // 1. Build the form FIRST
    this.initializeForm();
    this.selectedUadsId = this.data.uadsId;
    // this.workflowStatus = this.data.workflowstatus;
    this.mode = this.data.mode;
    this.loggedInRole = this.sessionservice.getCurrentUserRole();

    if (this.mode == 'view') {

      this.formGroup?.disable();

    }

    this.loadDeclarationDetails();
    this.getDropdownOptions();

    this.handleFormStatus();

  }


  handleFormStatus() {
    this.formGroup.controls['questionnaire1'].valueChanges.subscribe(() => {
      const initialValue = this.formGroup.controls['questionnaire1'].getRawValue();

      this.formGroup.controls['questionnaire1'].valueChanges.subscribe(currentValue => {
        const hasChanged =
          JSON.stringify(initialValue) !== JSON.stringify(currentValue);

        if (hasChanged) {
          this.questionnaire1FormValid.set('In Review');
          this.submitmessage = '';
          this.formGroup.get('questionnaire1verified')?.setValue(false);

        }
      });
    });

    this.formGroup.controls['questionnaire2'].valueChanges.subscribe(() => {
      const initialValue = this.formGroup.controls['questionnaire2'].getRawValue();

      this.formGroup.controls['questionnaire2'].valueChanges.subscribe(currentValue => {
        const hasChanged =
          JSON.stringify(initialValue) !== JSON.stringify(currentValue);

        if (hasChanged) {
          this.questionnaire2FormValid.set('In Review');
          this.submitmessage = '';
          this.formGroup.get('questionnaire2verified')?.setValue(false);
        }
      });
    });


    this.formGroup.controls['questionnaire3'].valueChanges.subscribe(() => {
      const initialValue = this.formGroup.controls['questionnaire3'].getRawValue();

      this.formGroup.controls['questionnaire3'].valueChanges.subscribe(currentValue => {
        const hasChanged =
          JSON.stringify(initialValue) !== JSON.stringify(currentValue);

        if (hasChanged) {
          this.questionnaire3FormValid.set('In Review');
          this.submitmessage = '';
          this.formGroup.get('questionnaire3verified')?.setValue(false);
        }
      });
    });

    if (this.selectedUserrole !== 'Advisor') {
      this.formGroup.controls['questionnaire4'].valueChanges.subscribe(() => {
        const initialValue = this.formGroup.controls['questionnaire4'].getRawValue();

        this.formGroup.controls['questionnaire4'].valueChanges.subscribe(currentValue => {
          const hasChanged =
            JSON.stringify(initialValue) !== JSON.stringify(currentValue);

          if (hasChanged) {
            this.questionnaire4FormValid.set('In Review');
            this.submitmessage = '';
            this.formGroup.get('questionnaire4verified')?.setValue(false);
          }
        });
      });

      merge(
        this.formGroup.controls['questionnaire1'].valueChanges.pipe(skip(1)),
        this.formGroup.controls['questionnaire2'].valueChanges.pipe(skip(1)),
        this.formGroup.controls['questionnaire3'].valueChanges.pipe(skip(1)),
        this.formGroup.controls['questionnaire4'].valueChanges.pipe(skip(1))
      ).subscribe(() => {
        this.formGroup.get('allsectionverified')?.setValue(false);
      });
    } else {
      merge(
        this.formGroup.controls['questionnaire1'].valueChanges.pipe(skip(1)),
        this.formGroup.controls['questionnaire2'].valueChanges.pipe(skip(1)),
        this.formGroup.controls['questionnaire3'].valueChanges.pipe(skip(1)),
      ).subscribe(() => {
        this.formGroup.get('allsectionverified')?.setValue(false);
      });
    }
  }


  /**
   * Initializes the entire form structure
   */
  private initializeForm(): void {
    this.formGroup = this.fb.group({

      allsectionverified: [''],
      questionnaire1verified: [''],
      questionnaire2verified: [''],
      questionnaire3verified: [''],
      questionnaire4verified: [''],
      // PERSONAL INFO (Static)
      personalInfo: this.fb.group({
        fullName: [{ value: '', disabled: true }],
        representative_no: [{ value: '', disabled: true }],
        branch: [{ value: '', disabled: true }],
        repcode: [{ value: '', disabled: true }],
        nric: [{ value: '', disabled: true }],
        nationality: [{ value: '', disabled: true }],
        otherNationality: [{ value: '', disabled: true }],
        countryofbirth: [{ value: '', disabled: true }],
        fin_No: [{ value: '', disabled: true }],
        email: [{ value: '', disabled: true }],
        race: [{ value: '', disabled: true }],
        raceSpecify: [{ value: '', disabled: true }],
        maritalStatus: [{ value: '', disabled: true }],
        dob: [{ value: '', disabled: true }],
        address: [{ value: '', disabled: true }],
        postalCode: [{ value: '', disabled: true }],
        homenumber: [{ value: '', disabled: true }],
        mobilenumber: [{ value: '', disabled: true }],
      }),

      // SPOUSE (Static)
      spouseInfo: this.fb.group({
        spousename: [{ value: '', disabled: true }],
        spouse_no: [{ value: '', disabled: true }],
        spouse_dob: [{ value: '', disabled: true }],
        spouse_occupation: [{ value: '', disabled: true }],
        spouse_employer: [{ value: '', disabled: true }],
      }),

      // QUESTIONS (Dynamic)
      questionnaire1: this.buildQuestions(this.questionnaire1Questions),
      questionnaire2: this.buildQuestions(this.questionnaire2Questions),
      questionnaire3: this.buildQuestions(this.questionnaire3Questions),
      questionnaire4: this.buildQuestions(this.questionnaire4Questions),

      // MISCELLANEOUS
      miscellaneous: this.fb.group({
        additionalInfo: [{ value: '', disabled: true }],
      })
    });
  }

  // Your existing dynamic builder function
  buildQuestions(questions: any[]) {
    const group: any = {};

    if (!questions || questions.length === 0) {
      console.warn('buildQuestions was called with an empty or undefined question array.');
      return this.fb.group({});
    }

    questions.forEach((q) => {
      // 1. Initialize the individual Question Group structure
      const questionGroup = this.fb.group({
        answer: [{ value: '', disabled: true }],
        entityCount: [{ value: '', disabled: true }],
        noAttachment: [{ value: false, disabled: true }],
        noAttachmentReason: [{ value: '', disabled: true }],// Added form backing control

        attachment: this.fb.group({
          file: [null],
          fileName: [{ value: '', disabled: true }],
          documentPath: [{ value: '', disabled: true }]
        }),

        isVerified: [false],
        managerComment: [''],
        advisorComment: [{ value: '', disabled: true }],
        changed: ['']
      })
      // Assign to the main Form Group map using your unique configuration string ID
      group[q.id] = questionGroup;
    });

    return this.fb.group(group);
  }


  private getQuestionnaireName(categoryName: string): string {

    if (categoryName.startsWith('businessInterests_')) {
      return 'questionnaire1';
    }

    if (categoryName.startsWith('generalInformation_')) {
      return 'questionnaire2';
    }

    if (categoryName.startsWith('fitPropercriteria_')) {
      return 'questionnaire3';
    }

    if (categoryName.startsWith('Supervisor attestation_')) {
      return 'questionnaire4';
    }

    return '';
  }

  async loadDeclarationDetails() {
    this.setSprinner.set(true);
    let uadsId = this.selectedUadsId;

    const response = await this.dsuAdService.getAdvisordeclaration(uadsId)
      .then((response) => { // Force the type to 'any' instead of 'any[]'
        // console.log('Data received successfully:', dashboardList);
        return JSON.parse(response);

      })
      .catch((error) => {
        console.error('Error fetching dashboard data:', error.message);
      });

    this.setSprinner.set(false);

    if (response.status === HttpStatusCode.Ok) {
      this.declarationData = response.data.responsedata;
      this.questionset = this.declarationData.questionset;
      const personal = this.declarationData.personalinformation;
      this.selectedUserrole = personal.userRole;
      this.selectedPiasRepcode = personal.piasRepCode;
      this.workflowStatus = personal.anndeclareStatus.toUpperCase();
      this.workflowStatus.replace('_', ' ');

      const nationalityValue =
        personal?.nationality ?? '';

      const isSplitFormat =
        nationalityValue.startsWith('others,') ||
        nationalityValue.startsWith('Singapore Permanent Resident,');

      const nationality =
        isSplitFormat
          ? nationalityValue.split(',')[0]
          : nationalityValue;

      const otherNationality =
        isSplitFormat
          ? nationalityValue.split(',')[1]
          : nationalityValue === 'Singapore Citizen'
            ? 'Singaporean'
            : '';


      // Personal Info
      this.formGroup.get('personalInfo')?.patchValue({
        fullName: personal?.fullName,
        representative_no: personal?.masRepNo,
        branch: personal?.branch,
        repcode: personal?.piasRepCode,
        nric: personal?.nricNo,
        nationality,
        otherNationality,
        countryofbirth: personal?.countryofbirth,
        fin_No: personal?.finPassport,
        email: personal?.personalEmail,
        race: personal?.race,
        maritalStatus: personal?.martialStatus,
        address: personal?.userAddress,
        homenumber: personal?.houseNo,
        mobilenumber: personal?.mobile
      });

      // Spouse
      this.formGroup.get('spouseInfo')?.patchValue({
        spousename: personal?.spouseName,
        spouse_no: personal?.spouseNricNo,
        spouse_dob: personal?.spouseDob
          ? new Date(personal?.spouseDob)
          : null,
        spouse_occupation: personal?.spouseOccupation,
        spouse_employer: personal?.spouseEmployer
      });

      if (this.formGroup.get('personalInfo')?.get('maritalStatus')?.value.toLowerCase() != 'married') {
        this.formGroup.get('spouseInfo')?.reset();
      }

      // Miscellaneous
      this.formGroup.get('miscellaneous')?.patchValue({
        additionalInfo: personal?.additionalInformation
      });

      this.questionset.forEach((item: questionset) => {
        const questionnaire =
          this.getQuestionnaireName(item.categoryName);

        const questionGroup = this.formGroup.get(
          `${questionnaire}.${item.categoryName}`
        ) as FormGroup;

        if (!questionGroup) {
          // console.warn('Question not found:', item.categoryName);
          return;
        }

        questionGroup.patchValue({
          answer: item?.adviserBooleanResponse === 'True' ? true : false,
          entityCount: item?.adviserResponse,
          attachment: {
            fileName: item?.adviserAttachment,
            documentPath: item?.adviserAttachment
          },
          noAttachment: item?.adviserBooleanAttachment === 'False' ? false : true,
          noAttachmentReason: item?.adviserCommentAttachment,
          isVerified: item?.dsuResponse === 'NotChecked' ? false : true,
          managerComment: item.comments != null ? item?.comments[0].user_comment : '',
          advisorComment: item.advisorcomments != null ? item?.advisorcomments[0].user_comment : '',
          changed: item?.isDifferent
        });
      });

      let questioneries1flag = this.questionset
        .filter(item => item.categoryName.startsWith('businessInterests_'))
        .every(item => item.dsuResponse == 'Approved');

      if (questioneries1flag) {
        this.formGroup.get('questionnaire1verified')?.setValue(true);
        this.formValidators[0].set('Verified');
      }

      let questioneries2flag = this.questionset
        .filter(item => item.categoryName.startsWith('generalInformation_'))
        .every(item => item.dsuResponse == 'Approved');

      if (questioneries2flag) {
        this.formGroup.get('questionnaire2verified')?.setValue(true);
        this.formValidators[1].set('Verified');
      }

      let questioneries3flag = this.questionset
        .filter(item => item.categoryName.startsWith('fitPropercriteria_'))
        .every(item => item.dsuResponse == 'Approved');

      if (questioneries3flag) {
        this.formGroup.get('questionnaire3verified')?.setValue(true);
        this.formValidators[2].set('Verified');
      }

      if (this.selectedUserrole !== 'Advisor') {
        let questioneries4flag = this.questionset
          .filter(item => item.categoryName.startsWith('Supervisor attestation_'))
          .every(item => item.dsuResponse == 'Approved');

        if (questioneries4flag) {
          this.formGroup.get('questionnaire4verified')?.setValue(true);
          this.formValidators[3].set('Verified');
        }

        if (questioneries1flag == true && questioneries2flag == true && questioneries3flag == true && questioneries4flag == true) {
          this.formGroup.controls['allsectionverified'].setValue(true);
        } else {
          this.formGroup.controls['allsectionverified'].setValue(false);
        }
      } else {

        if (questioneries1flag == true && questioneries2flag == true && questioneries3flag == true) {
          this.formGroup.controls['allsectionverified'].setValue(true);
        } else {
          this.formGroup.controls['allsectionverified'].setValue(false);
        }

      }



    } else {
      if (response.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (response.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

    }
  }


  // Getter - points correctly to 'this.formGroup'
  getQuestionGroup(sectionName: string, questionId: string) {
    return this.formGroup.get(sectionName + '.' + questionId);
  }

  // Preview Methods
  async previewAttachment(sectionName: string, questionId: string) {
    const fileKey = sectionName + '_' + questionId;
    const group = this.getQuestionGroup(sectionName, questionId);

    const fileName = group?.get('attachment')?.get('fileName')?.value;

    try {

      const data = {
        documentname: fileName,
        questioncategory: questionId,
        userPiasCode: this.selectedPiasRepcode
      }

      const responseData = await this.dsuAdService
        .getDeclearionAttachements(data);

      // Create blob URL
      const fileURL = URL.createObjectURL(responseData);

      // Safe URL
      this.selectedDocument = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

    } catch (error) {
      console.error(error);
    }

    this.currentFileName = fileName;
    this.isPdf = fileName.toLowerCase().endsWith('.pdf');
    this.showPreview = true;
    this.resetZoom();

  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.MAX_ZOOM, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.MIN_ZOOM, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  closePreview(): void {
    this.showPreview = false;
    this.selectedDocument = null;
    this.currentFileName = '';
    this.resetZoom();
  }

  changeIndex(index: number) {
    this.currentStep = index;
  }

  async getDropdownOptions() {

    const responseData = await this.dsuAdService
      .getDropdownOptions()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });



    if (responseData.status === HttpStatusCode.Ok) {
      this.nationalities = responseData.data.responsedata.constants.nationality_list;
      this.countries = responseData.data.responsedata.constants.country_list;
    }
  }


  async saveAndContinue(sectionName: string) {

    let saveDsuquestionresponse = new AddsuModel();
    saveDsuquestionresponse.setuserPiasCode(this.declarationData.personalinformation.piasRepCode);
    if (this.currentStep == 2 || this.currentStep == 3 || this.currentStep == 4 || this.currentStep == 5) {

      const sectionGroup = this.formGroup.get(sectionName) as FormGroup;
      const formValues = sectionGroup.getRawValue();
      const questionIds = Object.keys(formValues);
      // console.log(this.formGroup.get(sectionName))

      // console.log(formArray);
      const savedResponse = questionIds.map(questionId => {
        const qData = formValues[questionId];
        return {
          questioncategory: questionId,
          userComment: qData.managerComment,
          isverified: qData.isVerified
        }
      });

      saveDsuquestionresponse.setdsuresponse(savedResponse);

      if (this.formGroup.controls[sectionName].valid) {
        const allVerified = Object.values(sectionGroup.controls).every(control => {
          return control.get('isVerified')?.value === true;
        });
        if (allVerified) {
          this.formValidators[this.currentStep - 2].set('Verified');
          this.formGroup.get(sectionName + 'verified')?.setValue(true);

        }
        this.currentStep++;

      }

      this.saveQuestionResponse(saveDsuquestionresponse);

    }
  }

  async saveQuestionResponse(saveDsuquestionresponse: AddsuModel) {
    this.setSprinner.set(true);
    const responseData = await this.dsuAdService
      .saveVerifydeclarationquestion(saveDsuquestionresponse)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.snackmessage.openSuccessSnackBar("Application saved successfully!");
      this.loadDeclarationDetails();

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

    }
  }

  async sectionVerified(checked: boolean, sectionName: string) {

    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: checked == true ? 'Are you sure you want to verified this section?' : 'Are you sure you want to unverified this section?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {

        const questionGroup = this.formGroup.get(sectionName) as FormArray;

        let index = Number(sectionName.substring(13));
        index = index - 1;

        if (checked == true) {

          Object.values(questionGroup.controls).forEach(question => {
            question.get('isVerified')?.setValue(true);
          })

          this.formValidators[index].set('Verified');

        } else {
          Object.values(questionGroup.controls).forEach(question => {
            question.get('isVerified')?.setValue(false);
          })

          this.formValidators[index].set('In Review');
        }

        this.saveAllSection(sectionName);
      } else {

        if (checked == true) {
          this.formGroup.controls[sectionName + 'verified']?.setValue(false);
        } else {
          this.formGroup.controls[sectionName + 'verified']?.setValue(true);
        }

      }
    });

  }

  async allSectionVerifed(checked: boolean) {

    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: checked == true ? 'Are you sure you want to verified All section?' : 'Are you sure you want to unverified All section?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        const questionnaires = [
          'questionnaire1',
          'questionnaire2',
          'questionnaire3',
          'questionnaire4'
        ].map(questions => this.formGroup.get(questions) as FormArray);


        if (checked == true) {
          this.formGroup.get('questionnaire1verified')?.setValue(true);
          this.formGroup.get('questionnaire2verified')?.setValue(true);
          this.formGroup.get('questionnaire3verified')?.setValue(true);
          if (this.selectedUserrole !== 'Advisor') {
            this.formGroup.get('questionnaire4verified')?.setValue(true);
          }
          Object.values(questionnaires).forEach((questions, index) => {

            Object.values(questions.controls).forEach((question) => {

              question?.get('isVerified')?.setValue(true);

            });

            this.formValidators[index].set('Verified');

          });

        } else {
          this.formGroup.get('questionnaire1verified')?.setValue(false);
          this.formGroup.get('questionnaire2verified')?.setValue(false);
          this.formGroup.get('questionnaire3verified')?.setValue(false);
          if (this.selectedUserrole !== 'Advisor') {
            this.formGroup.get('questionnaire4verified')?.setValue(false);
          }
          Object.values(questionnaires).forEach((questions, index) => {
            Object.values(questions.controls).forEach((question) => {

              question?.get('isVerified')?.setValue(false);

            });
            this.formValidators[index].set('In Review');
          });
        }

        this.saveAllSection('questionnaire1');
        this.saveAllSection('questionnaire2');
        this.saveAllSection('questionnaire3');
        if (this.selectedUserrole !== 'Advisor') {
          this.saveAllSection('questionnaire4');
        }

      } else {

        if (checked == true) {
          this.formGroup.controls['allsectionverified']?.setValue(false);
        } else {
          this.formGroup.controls['allsectionverified']?.setValue(true);
        }

      }
    });

  }

  async saveAllSection(sectionName: string) {
    let saveDsuquestionresponse = new AddsuModel();
    saveDsuquestionresponse.setuserPiasCode(this.declarationData.personalinformation.piasRepCode);


    const sectionGroup = this.formGroup.get(sectionName) as FormGroup;
    const formValues = sectionGroup.getRawValue();
    const questionIds = Object.keys(formValues);
    // console.log(this.formGroup.get(sectionName))

    // console.log(formArray);
    const savedResponse = questionIds.map(questionId => {
      const qData = formValues[questionId];
      return {
        questioncategory: questionId,
        userComment: qData.managerComment,
        isverified: qData.isVerified
      }
    });

    saveDsuquestionresponse.setdsuresponse(savedResponse);
    this.saveQuestionResponse(saveDsuquestionresponse);

  }

  async returnDeclaration() {
    let returnflag = signal(false);
    if (this.selectedUserrole !== 'Advisor') {
      returnflag.set(this.questionnaire1FormValid() == 'Verified' && this.questionnaire2FormValid() == 'Verified' && this.questionnaire3FormValid() == 'Verified' && this.questionnaire4FormValid() == 'Verified' ? true : false);
    } else {
      returnflag.set(this.questionnaire1FormValid() == 'Verified' && this.questionnaire2FormValid() == 'Verified' && this.questionnaire3FormValid() == 'Verified' ? true : false);
    }
    if (returnflag() == false) {
      const dialogRef = this.dialog.open(ConfirmPopupComponent, {
        width: '500px',
        disableClose: true,
        data: {
          message: 'Are you sure you want to return this Declaration?',
          hidecancel: false,
        }
      });

      dialogRef.afterClosed().subscribe(async result => {
        if (result.data === true) {

          this.setSprinner.set(true);

          const responseData = await this.dsuAdService
            .returnDeclarationquestion(this.selectedPiasRepcode)
            .then((response) => {
              return JSON.parse(response);
            })
            .catch((error) => {
              // console.error(error);
              return error;
            });
          this.setSprinner.set(false);
          if (responseData.status === HttpStatusCode.Ok) {
            this.loadDeclarationDetails();
            this.snackmessage.openSuccessSnackBar("Application Returned successfully!");
            this.router.navigate(['/annual-declaration']);

          } else {
            if (responseData.code === HttpStatusCode.BadRequest) {
              // Display notification on API failure.
              this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
            }
            if (responseData.code === HttpStatusCode.Unauthorized) {
              this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
              this.router.navigate(['/login']);
            }
          }

        } else {


        }
      });
    } else {
      this.submitmessage = 'All sections have been verified, and we are not able to return the Declaration.';
    }


  }

  async submitForm() {
    let submitflag = signal(false);
    if (this.selectedUserrole !== 'Advisor') {
      submitflag.set(this.questionnaire1FormValid() == 'Verified' && this.questionnaire2FormValid() == 'Verified' && this.questionnaire3FormValid() == 'Verified' && this.questionnaire4FormValid() == 'Verified' ? true : false);
    } else {
      submitflag.set(this.questionnaire1FormValid() == 'Verified' && this.questionnaire2FormValid() == 'Verified' && this.questionnaire3FormValid() == 'Verified' ? true : false);
    }
    if (submitflag()) {
      const dialogRef = this.dialog.open(ConfirmPopupComponent, {
        width: '500px',
        disableClose: true,
        data: {
          message: 'Are you sure you want to submit this Application?',
          hidecancel: false,
        }
      });

      dialogRef.afterClosed().subscribe(async result => {
        if (result.data === true) {

          this.setSprinner.set(true);

          const responseData = await this.dsuAdService
            .submitapprovedeclarationquestion(this.selectedPiasRepcode)
            .then((response) => {
              return JSON.parse(response);
            })
            .catch((error) => {
              // console.error(error);
              return error;
            });
          this.setSprinner.set(false);
          if (responseData.status === HttpStatusCode.Ok) {
            this.loadDeclarationDetails();
            this.snackmessage.openSuccessSnackBar("Application submitted successfully!");
            this.router.navigate(['/annual-declaration']);

          } else {
            if (responseData.code === HttpStatusCode.BadRequest) {
              // Display notification on API failure.
              this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
            }
            if (responseData.code === HttpStatusCode.Unauthorized) {
              this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
              this.router.navigate(['/login']);
            }
          }

        } else {


        }
      });

    } else {
      this.submitmessage = 'Complete and Save all sections before submit';

    }
  }
}